import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/Auth/auth";
import { Wrap } from "./style";
const RegisterRealtorComponent = () => {
  const [state, setState] = useState({
    email: "",
    firstname: "",
    lastname: "",
    password: "",
    roleIdSet: [0],
  });
  const [loginState, setLoginState] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [pass, setPass] = useState({
    pass: "",
    repass: "",
  });
  const navigate = useNavigate();
  const auth = AuthContext();
  const onChange = ({ target }) => {
    const { name, value } = target;
    setState({
      ...state,
      [name]: value,
    });

    if (name === "re-enter") {
      setPass({
        ...pass,
        repass: value,
      });
    }
    if (name === "password") {
      setPass({
        ...pass,
        pass: value,
      });
    }

    if (pass?.pass === pass?.repass) {
      setError(!error);
    }
  };

  const onRegister = () => {
    if (error) {
      auth?.register(state, () => {});
    } else alert("Didnt match");
  };
  const onChangeLogin = ({ target }) => {
    const { name, value } = target;
    setLoginState({
      ...loginState,
      [name]: value,
    });
  };
  const onLogin = () => {
    console.log(loginState);
    auth?.login(loginState, () => {
      navigate("/sell/dashboard");
    });
  };
  console.log(error);
  return (
    <Wrap>
      <Wrap.Sign>
        <Wrap.Title>Sign in</Wrap.Title>
        <Wrap.SubTitle>Login</Wrap.SubTitle>
        <Wrap.Input
          placeholder="Username"
          type="email"
          name="email"
          onChange={onChangeLogin}
        />
        <Wrap.Input
          placeholder="Password"
          type="password"
          name="password"
          onChange={onChangeLogin}
        />
        <Wrap.Remember>
          <input type="checkbox" id="check" />
          <label htmlFor="check">Remember me</label>
          <a href="/">Forgot</a>
        </Wrap.Remember>
        <Wrap.Button onClick={onLogin}>sign in</Wrap.Button>
        <Wrap.UserInfo>
          <div className="name">
            Username: <span>agency or agent</span>
          </div>
          <div className="pass">
            Password: <span>demo</span>
          </div>
        </Wrap.UserInfo>
      </Wrap.Sign>

      <Wrap.Register>
        <Wrap.Title>Sign in</Wrap.Title>

        <Wrap.Input
          placeholder="First name"
          required
          type="text"
          name="firstname"
          onChange={onChange}
        />
        <Wrap.Input
          placeholder="Last name"
          required
          type="text"
          name="lastname"
          onChange={onChange}
        />
        <Wrap.Input
          placeholder="Email"
          required
          type="text"
          name="email"
          autocomplete="off"
          onChange={onChange}
        />
        <Wrap.Input
          placeholder="Password"
          required
          autocomplete="off"
          type="password"
          name="password"
          onChange={onChange}
        />
        {/* <div style={{ position: "relative" }}>
          <Wrap.Input
            placeholder="Re-enter password"
            required
            type="password"
            name="re-enter"
            onChange={onChange}
          />
          <Wrap.ReEnter>
            {error ? "password didnt match" : error === "" ? "" : "matched"}
          </Wrap.ReEnter>
        </div> */}

        <Wrap.Button onClick={onRegister} bg="#0D263B">
          REGISTER
        </Wrap.Button>
      </Wrap.Register>
      {/* <input
        style={{ background: "#ddd" }}
        required
        type="text"
        name="firstname"
        onChange={onChange}
      />
      <input
        required
        style={{ background: "#ddd" }}
        type="text"
        name="lastname"
        onChange={onChange}
      />
      <input
        required
        style={{ background: "#ddd" }}
        type="email"
        name="email"
        onChange={onChange}
      />
      <input
        required
        style={{ background: "#ddd" }}
        type="password"
        name="password"
        onChange={onChange}
      />
      <input type="button" onClick={onRegister} value="register" /> */}
    </Wrap>
  );
};

export default RegisterRealtorComponent;
